import { useMemo } from 'react'

import { StatusBadge, Table } from '@domain-group/suit-theme'
import type { Column } from '@domain-group/suit-theme/dist/components/Table'

import useSelector from '@hooks/useSelector'

import type { CampaignPortalSyncModel } from '@models/types'

import type { EntitiesState } from '@redux/entities'

import CampaignPortalSyncsActions from './CampaignPortalSyncsActions'

interface CampaignPortalSyncsTableProps {
  campaignPortalSyncs: CampaignPortalSyncModel[],
}

const buildColumns = (portals: EntitiesState['portals']) => [
  {
    title: 'Action',
    dataKey: 'sync_type',
    cellProps: {
      style: { textTransform: 'capitalize' },
      width: 140,
    },
  },
  {
    title: 'Portal',
    dataKey: 'portal_id',
    render: (portal_id: number) => portals[portal_id]?.title,
  },
  {
    title: 'Identity Code',
    dataKey: 'identity_code',
    cellProps: {
      width: 140,
    },
  },
  {
    title: 'Unique ID',
    dataKey: 'unique_id',
    cellProps: {
      width: 140,
    },
  },
  {
    title: 'Date and Time',
    dataKey: 'dates.synced.date_time',
    cellProps: {
      width: 150,
    },
  },
  {
    title: 'Status',
    cellProps: {
      textAlign: 'center',
    },
    dataKey: 'success',
    render: (success: boolean) => (
      <StatusBadge
        // @ts-expect-error
        key={success}
        color={success ? 'green' : 'orange'}
        ghost
        text={success ? 'SUCCESS' : 'FAIL'}
      />
    ),
  },
  {
    title: 'Actions',
    dataKey: 'id',
    cellProps: {
      width: 80,
      textAlign: 'center',
    },
    // @ts-expect-error TS2322
    render: id => <CampaignPortalSyncsActions campaignPortalSync={{ id }} />,
  },
]

const CampaignPortalSyncsTable = (props: CampaignPortalSyncsTableProps) => {
  const { campaignPortalSyncs } = props

  const portals = useSelector(reduxState => reduxState.entities.portals)

  const memoColumns = useMemo(() => buildColumns(portals), [campaignPortalSyncs.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 300, overflowY: 'auto' }}
      // @ts-expect-error
      columns={memoColumns}
      scroll={{ x: 900 }}
      data={campaignPortalSyncs}
      stickyHeader
    />
  )
}

export default CampaignPortalSyncsTable
